<!-- 包装及规格参数 -->
<template>
  <!-- 产品参数弹框 -->
  <div class="spec-content" v-if="skuInfo && skuInfo.parameters">
    <div class="content" ref="content" :class="showTotal ? 'total-introduce' : 'detailed-introduce'">
      <div class="row" v-for="v in parameters" :key="v.id">
        <div class="title">{{ v.name }}</div>
        <div class="item" v-for="item in v.items" :key="item.id">
          <img v-if="item.imgUrl" class="item-img" :src="item.imgUrl" alt="" />
          <div v-else class="item-text" tabindex="0">
            <div class="text-left">{{ item.name }}</div>
            <!-- 规格说明是富文本 -->
            <div class="text-right" v-html="item.value"></div>
          </div>
        </div>
      </div>
      <div class="shad" v-if="!exchangeButton && showExchangeButton"></div>
    </div>
    <div class="bottom" v-if="showExchangeButton">
      <div id="detailTop" class="button" @click="toogle" aria-hidden="true">
        <span class="word" v-if="!exchangeButton">展开</span>
        <span class="word" v-else>收起</span>
        <v-icon name="arrow-right-v3" :class="[!exchangeButton ? 'shou-qi' : 'zhan-kai']"></v-icon>
      </div>
    </div>
  </div>
</template>

<script>
// import { scrollY } from '@/utils/scroll'
export default {
  name: 'SpecRule',
  props: ['skuInfo'],
  data() {
    return {
      // 显示展开还是收起
      exchangeButton: false,
      // 是否显示展开收起按钮
      showExchangeButton: false,
      // 是否展示所有文本内容
      showTotal: true,
      heightNum: 0
    }
  },
  computed: {
    parameters() {
      let result = (this.skuInfo?.parameters || []).filter(item => item.isKey != 2)
      return result || []
    }
  },
  mounted() {
    let height = this.$refs?.content?.offsetHeight
    if (height > 517) {
      this.showTotal = false
      this.showExchangeButton = true
    } else {
      this.showTotal = true
      this.showExchangeButton = false
    }
  },
  methods: {
    toogle() {
      if (this.exchangeButton == true) {
        var topNum = document.documentElement.scrollTop || document.body.scrollTop
        var s = topNum - (document.getElementById('detailTop').offsetTop - this.heightNum)
        // 不用scrollY方法，此方法会增加过渡效果，有兼容性问题，而且此位置不要过渡更好
        window.scrollTo(0, s)
        this.showTotal = !this.showTotal
        this.exchangeButton = !this.exchangeButton
      } else {
        this.heightNum = document.getElementById('detailTop').offsetTop
        this.showTotal = !this.showTotal
        this.exchangeButton = !this.exchangeButton
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss" />
